import { useRef } from 'react';

import { cn } from 'lib/helpers/utility';

import PayOnlineButton from './PayOnlineButton';
import ErrorMessage from './components/ErrorMessage';
import Label from './components/Label';
import LoadingWrapper from './components/LoadingWrapper';
import { usePayroc } from './hooks/usePayroc';

import './Payroc.scss';

const PayrocOnlinePayment = ({
  id,
  amount,
  handlePayment,
  validate,
  children,
  buttonText,
  hideButton = false,
  mode,
  secureTokenId,
  flexRow,
  onError,
  terminalId
}) => {
  const containerRef = useRef(null);
  const { isLoading } = usePayroc({
    id,
    amount,
    validate,
    type: 'card',
    containerRef,
    handlePayment,
    buttonText,
    hideButton,
    mode,
    secureTokenId,
    terminalId,
    onError
  });

  return (
    <LoadingWrapper isLoading={isLoading} id={id}>
      <div
        ref={containerRef}
        className="card-container payroc-form flex h-full w-full flex-col items-center justify-center gap-4 p-1">
        <div className={cn('flex w-full flex-col gap-1', flexRow && 'flex-row gap-3 sm:flex-col')}>
          <div className="flex w-full flex-col gap-1">
            <Label htmlFor="card-holder-name" required>
              Cardholder name
            </Label>
            <div className="card-holder-name-wrapper payment-input-wrapper">
              <div className="card-holder-name w-full" id="card-holder-name"></div>
            </div>
            <ErrorMessage className="card-holder-name-error" />
          </div>
          <div className="flex w-full flex-col gap-1">
            <Label htmlFor="card-number" required>
              Card number
            </Label>
            <div className="payment-input-wrapper card-number-wrapper">
              <div className="card-number w-full" id="card-number"></div>
            </div>
            <ErrorMessage className="card-number-error" />
          </div>
        </div>
        <div className="flex w-full gap-3 sm:flex-col">
          <div className="flex w-full flex-col gap-1">
            <Label htmlFor="card-expiry" required>
              Expiration
            </Label>
            <div className="payment-input-wrapper card-expiry-wrapper">
              <div className="card-expiry w-full" id="card-expiry"></div>
            </div>
            <ErrorMessage className="card-expiry-error" />
          </div>
          <div className="flex w-full flex-col gap-1">
            <Label htmlFor="card-cvv" required>
              CVC
            </Label>
            <div className="payment-input-wrapper card-cvv-wrapper">
              <div className="card-cvv w-full" id="card-cvv"></div>
            </div>
            <ErrorMessage className="card-cvv-error" />
          </div>
        </div>
        {children}
        {!hideButton && <PayOnlineButton />}
      </div>
    </LoadingWrapper>
  );
};

export default PayrocOnlinePayment;
